import React from "react";

function CTFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="wrap">
          <nav className="navigation-footer">
          <a
            className="nav-link"
            href="https://www.ctunitedway.org/"
            aria-label="United Way of Connecticut logo link"
            target="_blank"
          >
            <div className="logo-uwc"></div>
          </a>
          <div className="footer-links">
            <ul className="menu-nav">
              <li className="nav-item">
                <strong>
                  <a className="nav-link top-level" href="http://uwc.211ct.org/about/" target="_blank">
                    About 211
                  </a>
                </strong>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="http://www.ctunitedway.org/aboutus/job-postings/"
                  rel="noopener"
                  target="_blank"
                >
                  Careers
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.ctunitedway.org/mediacenter/media-request/" target="_blank">
                  Media Requests
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.ctunitedway.org/news/" target="_blank">
                  News
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="http://uwc.211ct.org/about/privacypolicy/" target="_blank">
                  Privacy Policy
                </a>
              </li>
            </ul>
            <ul className="menu-nav">
              <li className="nav-item">
                <strong>
                  <a className="nav-link top-level" href="http://uwc.211ct.org/" target="_blank">
                    Get Help
                  </a>
                </strong>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="http://www.211childcare.org/" target="_blank">
                  211 Child Care
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.211navigator.org/" target="_blank">
                  211 Navigator
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="http://cdi.211ct.org/" target="_blank">
                  211 Child Development
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.ctcare4kids.com/" target="_blank">
                  Care4Kids
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.preventsuicidect.org/" target="_blank">
                  Prevent Suicide CT
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="http://www.cthcvp.org/" target="_blank">
                  Section 8
                </a>
              </li>
            </ul>
            <ul className="menu-nav">
              <li className="nav-item">
                <strong>
                  <a className="nav-link top-level" href="http://uwc.211ct.org/professionals/" target="_blank">
                    Professionals
                  </a>
                </strong>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="http://ct.211counts.org/" rel="noopener" target="_blank">
                  2-1-1 Counts
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="http://uwc.211ct.org/professionals/directories/" target="_blank">
                  Directories
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="http://uwc.211ct.org/professionals/materials" target="_blank">
                  Materials
                </a>
              </li>
            </ul>
            <ul className="menu-nav">
              <li className="nav-item">
                <strong>
                  <a className="nav-link top-level" href="http://uwc.211ct.org/contact/" target="_blank">
                    Contact
                  </a>
                </strong>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="tel: 211">
                  Dial 2-1-1
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="tel: 18002031234">
                  Dial 1-800-203-1234
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="tel: 711">
                  TTY/Relay: 7-1-1
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <div className="footer-bottom">
          <p className="call-out">
            Please read the important information <a href="https://uwc.211ct.org/professionals/inclusion/" target="_blank">at this link</a> about the agencies and organizations listed in our database.
          </p>
          <p className="call-out">
            211 is a program of United Way of Connecticut and is supported by the State of Connecticut and Connecticut
            United Ways.
          </p>
        </div>
        </div>
      </div>
    </footer>
  );
}

export default CTFooter;
